import { render, staticRenderFns } from "./ownerCars.vue?vue&type=template&id=228121bd&scoped=true"
import script from "./ownerCars.vue?vue&type=script&lang=js"
export * from "./ownerCars.vue?vue&type=script&lang=js"
import style0 from "./ownerCars.vue?vue&type=style&index=0&id=228121bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228121bd",
  null
  
)

export default component.exports